import { FieldArray as FormikFieldArray } from 'formik';
import { Row, Col, FormGroup } from 'reactstrap';
import { Input } from '@availity/form';
import Label from './Label';

const FieldArrayForm = ({ name, label, fields, defaultItem, values }) => {
  const items = values?.[name] || [];

  return (
    <FormikFieldArray
      name={name}
      render={(arrayHelpers) => (
        <FormGroup>
          <Label name={name} label={label} />
          <button
            type="button"
            className="btn btn-sm btn-outline btn-light ml-4"
            onClick={() => arrayHelpers.push(defaultItem)}
          >
            <i className="bx bx-plus font-size-11 align-middle"></i> Add
          </button>
          {Array.isArray(items) &&
            items.map((_, index) => (
              <Row key={index} className="mb-2 align-items-end">
                {fields.map((field) => (
                  <Col
                    md={field.col || Math.floor(10 / fields.length)}
                    key={field.name}
                  >
                    <FormGroup className="mb-0">
                      <Label
                        name={`${name}.${index}.${field.name}`}
                        label={field.label}
                      />
                      <Input
                        type={field.type || 'text'}
                        name={`${name}.${index}.${field.name}`}
                        id={`${name}.${index}.${field.name}`}
                        style={{ border: '1px solid #555' }}
                      />
                    </FormGroup>
                  </Col>
                ))}
                <Col md="2">
                  <button
                    className="btn btn-danger p-0"
                    style={{ width: '31px', height: '31px' }}
                    type="button"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    <i className="bx bx-trash d-block font-size-15" />
                  </button>
                </Col>
              </Row>
            ))}
        </FormGroup>
      )}
    />
  );
};

export default FieldArrayForm;
